/**
 * Simple UID generator. Increments every time it's used.
 */
let n = 0
export function generateUid() {
  return n++
}
